module.exports = __webpack_public_path__ + "static/img/valparaiso_projects_grulla.57cee99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/valparaiso_projects_grulla.jpg
// module id = 211
// module chunks = 0